import {
  actionChannel,
  all,
  call,
  delay,
  flush,
  fork,
  put,
  select,
  take
} from '@redux-saga/core/effects'
import ExchangeService from 'src/services/ExchangeService'
import OfferService from 'src/services/OfferService'
import ReservationService from 'src/services/ReservationService'
import { NOTIFICATION_EVENT_USER_NOTIFICATION_SENT } from 'src/features/notifications/duck/actions'

export const SET_MY_OFFERS_RESERVATION_UPDATES =
  'SET_MY_OFFERS_RESERVATION_UPDATES'
export const UPDATE_MY_OFFER_RESERVATIONS = 'UPDATE_MY_OFFER_RESERVATIONS'

const services = {
  exportOngoing: {
    offer: ExchangeService.showExportOffer,
    reservations: ReservationService.showOngoingExportOfferReservations
  },
  importOngoing: {
    offer: ExchangeService.showImportOffer,
    reservations: OfferService.showOngoingImportOfferReservations
  },
  generalOngoing: {
    offer: ExchangeService.showGeneralOffer,
    reservations: OfferService.showOngoingGeneralOfferReservations
  },
  postImportOngoing: {
    offer: ExchangeService.showPostImportOffer,
    reservations: OfferService.showOngoingPostImportOfferReservations
  },
  freeCarrierOngoing: {
    offer: ExchangeService.showFreeCarrierOffer,
    reservations: OfferService.showOngoingFreeCarrierOfferReservations
  }
}

const reservationNotificationCodes = [
  'offer.regular.queue.reserved',
  'offer.regular.queue.reservation.annulled'
]

const isReservationNotification = action =>
  action.type === NOTIFICATION_EVENT_USER_NOTIFICATION_SENT &&
  reservationNotificationCodes.includes(action.payload?.data?.code) &&
  action.payload?.data?.offer?.id != null

function* refreshReservations(listKey, id) {
  try {
    const [offer, reservations] = yield all([
      call(services[listKey].offer, { id }),
      call(services[listKey].reservations, id)
    ])
    if (
      !Number.isFinite(offer.data.reservationsCount) ||
      !Array.isArray(reservations.data)
    ) {
      throw new Error('Invalid offer reservations response')
    }
    yield put({
      type: UPDATE_MY_OFFER_RESERVATIONS,
      payload: {
        listKey,
        id,
        reservationsCount: offer.data.reservationsCount,
        reservations: reservations.data
      }
    })
  } catch (error) {
    // Keep the existing row if a background refresh fails.
    console.error('Could not refresh offer reservations', error)
  }
}

export function* watchMyOffersReservationUpdates() {
  const channel = yield actionChannel(isReservationNotification)
  try {
    while (true) {
      const first = yield take(channel)
      // Coalesce bursts, retaining events received during the preceding request.
      yield delay(250)
      const pending = yield flush(channel)
      const notifications = [first, ...pending]
      const myOffers = yield select(state => state.myOffers)
      const updates = []

      Object.keys(services).forEach(listKey => {
        const list = myOffers[listKey]
        if (!list.reservationUpdatesEnabled) return

        list.offers.forEach(offer => {
          const affected = notifications.some(({ payload }) => {
            const notifiedOffer = payload.data.offer
            const referenceNumber =
              notifiedOffer.referenceNumber || notifiedOffer.reference_number
            return (
              String(notifiedOffer.id) === String(offer.id) &&
              (!referenceNumber || referenceNumber === offer.referenceNumber)
            )
          })
          if (affected) {
            updates.push(call(refreshReservations, listKey, offer.id))
          }
        })
      })
      yield all(updates)
    }
  } finally {
    channel.close()
  }
}

export const myOffersReservationUpdatesSagas = [
  fork(watchMyOffersReservationUpdates)
]
